import { useCallback, useState } from 'react';
import { saveAs } from 'file-saver';
import { toast } from 'sonner';

export function useExport() {
  const [isExporting, setIsExporting] = useState(false);

  const exportFile = useCallback(async (
    fetchFn: () => Promise<Blob>,
    filename: string,
  ) => {
    setIsExporting(true);
    try {
      const blob = await fetchFn();
      saveAs(blob, filename);
      toast.success('Export completed successfully');
    } catch {
      toast.error('Failed to export file');
    } finally {
      setIsExporting(false);
    }
  }, []);

  return { exportFile, isExporting };
}
